import { MyleHelper } from "@/Common/Helpers/MyleHelper";
import { IServiceComboGridModel } from "../UI/ServiceCombo/IServiceComboGridModel";

class ServiceComboDisplaySettingsModel {
    public SitesId: string[];
    public Sites_AllSelected: boolean;
    public SpecializationsId: string[];
    public Specializations_AllSelected: boolean;
    public TypesId: string[];
    public Types_AllSelected: boolean;
    public EmployeeIds: string[];
    public Employees_AllSelected: boolean;
    public Status_AllSelected: boolean;
    public Status_IsActiveChecked: boolean;
    public Status_IsInactiveChecked: boolean;

    public static FromModel(model: IServiceComboGridModel): ServiceComboDisplaySettingsModel {
        const helper = new MyleHelper();

        let displaySettingsModel: ServiceComboDisplaySettingsModel = <ServiceComboDisplaySettingsModel>{
            SitesId: helper.GetCheckedItemsFromICheckableList(model.get("Sites")).map(checkable => checkable.Id).toArray(),
            Sites_AllSelected: model.get("Sites_AllSelected"),
            SpecializationsId: helper.GetCheckedItemsFromICheckableList(model.get("Specializations")).map(checkable => checkable.Id).toArray(),
            Specializations_AllSelected: model.get("Specializations_AllSelected"),
            TypesId: helper.GetCheckedItemsFromICheckableList(model.get("Types")).map(checkable => checkable.Id).toArray(),
            Types_AllSelected: model.get("Types_AllSelected"),
            EmployeeIds: helper.GetCheckedItemsFromICheckableList(model.get("EmployeesGlobalCache")).map(checkable => checkable.Id).toArray(),
            Employees_AllSelected: model.get("Employees_AllSelected"),
            Status_AllSelected: model.get("Status_AllSelected"),
            Status_IsActiveChecked: model.get("Status_IsActiveChecked"),
            Status_IsInactiveChecked: model.get("Status_IsInactiveChecked")
        };

        return displaySettingsModel;
    }
}

export { ServiceComboDisplaySettingsModel };
